<template>
  <div>
    <v-dialog
        persistent
        v-model="dialogStatus"
        width="700"
    >
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-center text-h5 font-weight-bold" style="color: #3A3852">
              {{confirmationTitle}}
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          {{confirmationText}}
          <div class="green-text">
            {{ currentItem.headline }}
          </div>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn :class="btnColor" @click="updateStatus">
              YES, I AM SURE
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="search_btn_wrap flex v_center">
      <h1 class="mb-0 mr-4">Affiliate News</h1>
      <v-btn
          color="primary"
          x-small
          :disabled="!isEditAccess"
          @click="showPopup = true, selectedItem = null"
          style="min-width: 0; min-height: 30px"
      >
        <span style="font-size: 24px">
          <i class="fas fa-plus"></i>
        </span>
      </v-btn>
    </div>

    <v-data-table
        :headers="table.headers"
        :items="getAffiliateNews.data"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :server-items-length="getAffiliateNews.count"
        :disable-sort="true"
        :footer-props="{ itemsPerPageOptions: table.pageOptions }"
        :items-per-page="table.perPage"
        :loading="table.loading"
        item-key="id"
        loading-text="Loading... Please wait"
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        fixed-header
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
    >
    <template v-slot:top>
      <DataTableTopBar @search="search"></DataTableTopBar>
    </template>

      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter :type="header.type"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <v-switch
            v-model="item.status === 'active'"
            class="mr-2"
            :key="item.id + '-' + item.status"
            @change="handleStatusChange(item)"
            :style="{
              '--v-switch-track-color': item.status === 'active' ? '#CCE5E5' : '#FADBD8',
              '--v-switch-thumb-color': item.status === 'active' ? '#008080' : '#FF6347'
            }"
        ></v-switch>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon color="primary" @click="editItem(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-btn icon color="primary" @click="copyItem(item)">
          <v-icon>mdi-checkbox-multiple-blank</v-icon>
        </v-btn>

        <v-btn icon color="primary" @click="history(item)">
          <v-icon>mdi-history</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <AffiliateNewsPopup
        :value="showPopup"
        :item="this.selectedItem ? this.selectedItem : null"
        v-if="showPopup"
        @close="showPopup = false"
        @createOrUpdateNews="handleCreateOrUpdateNews"
    />

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DataTableTopBar from "@/components/common/DataTableTopBar.vue";
import AffiliateNewsPopup from "@/components/pages/affiliates/affiliateNews/AffiliateNewsPopup.vue";

export default {
  name: 'AffiliateAlerts',
  components: { AffiliateNewsPopup, DataTableTopBar },
  computed: {
    ...mapGetters('affiliateNews', ['getAffiliateNews','filters']),
    ...mapState('user', ['user']),
  },
  methods: {
    ...mapActions('affiliateNews', [
      'getAffiliateNewsStore',
      'getAffiliateNewsFilterDataStore',
      'createOrUpdateAffiliateNewsStore'
    ]),
    search(searchText) {
      this.searchIn = searchText;
      this.submitFilter();
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    handleStatusChange(item) {
      this.currentItem = item;
      if (item.status === 'active') {
        item.status = 'inactive';
        this.confirmationTitle = 'Hide News on the Dashboard?';
        this.confirmationText = 'You are about to hide the news on the Dashboard';
        this.btnColor = 'red-btn';
      } else {
        item.status = 'active';
        this.confirmationTitle = 'Publish News on the Dashboard?';
        this.confirmationText = 'You are about to publish the news on the Dashboard';
        this.btnColor = 'green-btn';
      }
      this.currentItem = { ... item}
      this.dialogStatus = true;
    },
    async getFiltersData() {
      Object.keys(this.table.filters).forEach(name => {
        if (this.filters[name]) {
          this.table.filters[name]['data'] = this.filters[name];
          if (this.table.filters[name]['isRange']) {
            this.table.filters[name].min = Number(this.filters[name].find(f => f.key === 'min')['value']);
            this.table.filters[name].max = Number(this.filters[name].find(f => f.key === 'max')['value']);
          }
        }
        this.table.filters[name].data = this.filters[name]
      })
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.searchIn.length > 0) ? this.searchIn : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0) ?
            `'${this.table.filters[name].selected.join('\',\'')}'` :
            null;
      }
      return filters;
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    async copyItem(item) {
      let copyItem = { ...item };
      copyItem.id = null;

      let baseName = item.headline.replace(/(\s*-?\s*Copy\s*\d*)?$/, '');
      let copyNumber = 1;
      let copyName = `${baseName} - Copy`;

      while (true) {
        let existingCopy = this.checkIfCopyExists(copyName);
        if (!existingCopy) {
          copyItem.headline = copyName;
          copyItem.status = 'inactive';
          copyItem.isEdit = false;
          await this.createOrUpdateAffiliateNewsStore(copyItem);
          break;
        } else {
          copyName = `${baseName} - Copy ${copyNumber++}`;
        }
      }
    },

    checkIfCopyExists(headline) {
      return this.getAffiliateNews.data.some(item => item.headline === headline);
    },
    async editItem(item) {
      this.selectedItem = item;
      this.showPopup = true;
      return this.selectedItem;
    },
    async history(item) {
      await this.$router.push(`/affiliates/news/history/${item.id}`);
    },
    async handleCreateOrUpdateNews(newsData) {
      await this.createOrUpdateAffiliateNewsStore(newsData);
      this.showPopup = false;
    },
    async getTableData() {
      this.table.loading = true
      const filters = await this.getFilters();
      await this.getAffiliateNewsStore({
        filters,
        limit: this.table.itemsPerPage,
        page: this.table.currentPage,
        orderBy: this.table.orderBy,
        orderDirectionAsc: this.table.sortColumnsAsc,
      });
      this.table.loading = false
    },
    updateTablePagination(params){
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      //await this.getTableData()
    },
    async updateStatus() {
      await this.createOrUpdateAffiliateNewsStore({
        id: this.currentItem.id,
        status: this.currentItem.status,
        headline: this.currentItem.headline,
        news: this.currentItem.news,
        isEdit: true
      });
      this.dialogStatus = false;
      this.$forceUpdate();
    },
    closeModal() {
      this.getAffiliateNews.data.forEach((item, index) => {
        if (item.id === this.currentItem.id) {
          this.getAffiliateNews.data[index].status = this.currentItem.status === 'active' ? 'inactive' : 'active';
        }
      });
      this.dialogStatus = false;
    }
  },
  data() {
    return {
      searchIn: '',
      dialogStatus: false,
      currentItem: {},
      showPopup: false,
      selectedItem: null,
      isEditAccess: false,
      confirmationTitle: '',
      confirmationText: '',
      btnColor: '',
      table: {
        heightCounter: 48,
        loading: false,
        awaitingSearch: false,
        currentPage: 1,
        itemsPerPage: 25,
        pageChangedByMe: false,
        pageOptions: [25, 50, 100],
        orderBy: 'status',
        sortColumnsAsc: true,
        headers: [
          { text: 'ID', value: 'id', class: 'custom-header', type: 'items' },
          { text: 'Headline', value: 'headline',  type: 'items' },
          { text: 'Status', value: 'status',  type: 'items' },
          { text: 'News', value: 'news',  type: 'items' },
          { text: 'Published On', value: 'publishedOn',  type: 'date' },
          { text: 'Last Updated On', value: 'lastUpdatedOn',  type: 'date' },
          { text: 'Last Updated By', value: 'lastUpdatedBy',  type: 'items' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        filters: {
          id: {active: false, selected: [], show: false, property: '', data: []},
          headline: {active: false, selected: [], show: false, property: '', data: []},
          status: {active: false, selected: [], show: false, property: '', data: []},
          news: {active: false, selected: [], show: false, property: '', data: []},
          //publishedOn: {active: false, selected: [], show: false, property: '', data: []},
          //lastUpdatedOn: {active: false, selected: [], show: false, property: '', data: []},
          lastUpdatedBy: {active: false, selected: [], show: false, property: '', data: []},
        }
      },
      tableHeaders: [

      ],
    };
  },
  async mounted() {
    this.isEditAccess = true;
    // if (this.user[0].can('manage_dashboard_alerts')){
    //   this.isEditAccess = true;
    // }
    await this.getTableData()
    await this.getAffiliateNewsFilterDataStore();
    await this.getFiltersData()
  },
};
</script>

<style lang="sass" scoped>
 .header_title
   color: var(--v-primary-base) !important

.red-switch .v-input--selection-controls__input
  border-color: red

.red-btn
  color: white !important
  background-color: #F45151 !important

.red-text
  color: #F45151 !important

.green-btn
  color: white !important
  background-color: #358D83 !important

.green-text
  color: #358D83 !important

::v-deep .v-input--switch__thumb
  color: red !important
  margin-left: 10% !important


::v-deep .theme--light.v-input--switch .v-input--switch__track
   color: #f7594d !important
   height: 110% !important
   width: 120% !important
   margin-top: -15% !important
   border-radius: 20px !important

::v-deep .v-input--switch:not(.v-input--switch--flat):not(.v-input--switch--inset) input:checked ~ .v-input--switch__thumb
   background-color: green !important
   margin-left: 10% !important


::v-deep .theme--light.v-input--switch input:checked ~ .v-input--switch__track
   background-color: #8bc56e !important
   height: 110% !important
   width: 120% !important
   margin-top: -15% !important
   border-radius: 20px !important

</style>
